import { toast } from 'solid-sonner'

/* navigator.clipboard needs a secure context, which http://some-host:3000 is not.
   the textarea dance is the old way and works anywhere, so it's the fallback */
export async function copy(text: string, what = 'copied') {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
    } else {
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.append(area)
      area.select()
      document.execCommand('copy')
      area.remove()
    }
    toast.success(what)
  } catch {
    toast.error('could not copy')
  }
}
